export default {
  COMPLETE: 'complete',
  HALF_COMPLETE: 'half-complete', // credit results page is reached
};
